"use strict";
require('../../layouts/web')

$(document).ready(function() {
    $('.ecommmerce-slider').owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: true,
        slideTransition: 'linear',
        autoplayTimeout: 0,
        autoplaySpeed: 3000,
        autoplayHoverPause: false,
        responsiveClass: true,
    })
})

$(document).ready(function() {
    $('.banner-slider').owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 2,
            },
            600: {
                items: 3,
            },
            800: {
                items: 4,
            },

            1000: {
                items: 5,
            },
            1300: {
                items: 6,
            }


        }

    })
})

$(document).ready(function() {
    $('.post').owlCarousel({
        loop: false,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: false,
        nav: true,
        navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            800: {
                items: 2,
            },
            1000: {
                items: 3,
            }


        }

    })
})

$(document).ready(function() {
    $('.product-page').owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: true,
        nav: true,
        navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
        }

    })
})





$(document).ready(function() {
    $('.ios-features').owlCarousel({
        loop: true,
        margin: 30,
        items: 1,
        dots: false,
        autoplay: true,
        nav: true,
        navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
            },
            800: {
                items: 3,
            },

            1000: {
                items: 4,
            },

        }

    })
})

$(document).ready(function() {
    $('.ios-works').owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: true,
        nav: true,
        navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
        }

    })
})